export default __webpack_public_path__ + "static/escalator_b.f733ddcacb6be6172cffc9dae49a0bb8.png";